import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const ArrowDown: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5C12.5523 3.5 13 3.94772 13 4.5V17.0858L18.0429 12.0429C18.4334 11.6524 19.0666 11.6524 19.4571 12.0429C19.8476 12.4334 19.8476 13.0666 19.4571 13.4571L12.7071 20.2071C12.3166 20.5976 11.6834 20.5976 11.2929 20.2071L4.54289 13.4571C4.15237 13.0666 4.15237 12.4334 4.54289 12.0429C4.93342 11.6524 5.56658 11.6524 5.95711 12.0429L11 17.0858V4.5C11 3.94772 11.4477 3.5 12 3.5Z"
        fill="#C4FAC3"
      />
    </svg>
  );
};

export default ArrowDown;
